/// <summary>
/// Kỳ tính thuế trên X1 Online
/// </summary>
export default {
  Year: 4095,
  January: 1,
  February: 2,
  March: 4,
  April: 8,
  May: 16,
  June: 32,
  July: 64,
  August: 128,
  September: 256,
  October: 512,
  November: 1024,
  December: 2048,
  QuarterI: 7,
  QuarterII: 56,
  QuarterIII: 448,
  QuarterIV: 3584,
  FirtsHalfYear: 63,
  SecondHalfYear: 4032,
};
